import React, { Component } from 'react';
import { connect } from 'react-redux';

import Modal from '../../../../components/Modal';
import Select from '../../../../components/Select';
import RadioGroup, { Radio } from '../../../../components/RadioGroup';
import { getShippingGroups } from '../../../../redux/shipping-group';

import Breadcrumb from './Breadcrumb';
import Form from './Form';

const filters = {
  ALL: 'ALL',
  CUSTOM: 'CUSTOM',
};

class DashboardCompletedFilterShippingGroupModal extends Component {
  state = {
    value: this.isCustom || 0,
    isCustom: this.isCustom,
    selectedFilter: this.isCustom ? filters.CUSTOM : filters.ALL,
  }

  componentDidMount() {
    this.props.dispatch(getShippingGroups());
  }

  isCustom = this.props.selectedShippingGroup;

  _changeFilter = (type) => {
    if (type === filters.CUSTOM) {
      this.setState({ isCustom: true });
      return;
    }
    this.props.onApply(null);
  }

  _handleChange = (value) => {
    this.setState({
      value,
    });
  }

  _mapListToOptions = () => this.props.shippingGroupsList.map(shippingGroup => ({
    value: shippingGroup.id,
    label: shippingGroup.nome,
  }));

  _submit = () => this.props.onApply(this.state.value);

  _goBack = () => this.setState({ isCustom: false });

  _renderContent = () => {
    const { isCustom, selectedFilter } = this.state;

    if (isCustom) {
      return (
        <div>
          <Breadcrumb
            onBack={this._goBack}
            prev="Todos os filtros"
            current="Selecionar grupo"
          />
          <Form
            onSubmit={this._submit}
            submitText="Aplicar"
          >
            <Select
              options={this._mapListToOptions()}
              value={this.state.value}
              onChange={this._handleChange}
              closeOnSelect={false}
            />
          </Form>
        </div>
      );
    }

    return (
      <RadioGroup
        value={selectedFilter}
        onChangeValue={this._changeFilter}
      >
        <Radio
          value={filters.ALL}
          label="Todos os grupos"
        />
        <Radio
          value={filters.CUSTOM}
          label="Selecionar grupo"
        />
      </RadioGroup>
    );
  };

  render() {
    return (
      <Modal
        title="Selecionar grupo"
        size="small"
        onBackdropClick={this.props.onBackdropClick}
      >
        {this._renderContent()}
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  shippingGroupsList: state.shippingGroup.list,
});

export default connect(mapStateToProps)(DashboardCompletedFilterShippingGroupModal);
